/**
 * Pure base-URL helper for React Email templates.
 *
 * Kept separate from lib/email/shared.ts so that template components don't
 * transitively import createAdminClient or the app logger. Returns the canonical
 * site URL with trailing slashes stripped.
 */
export function getEmailBaseUrl(): string {
  return (process.env.NEXT_PUBLIC_BASE_URL || 'https://alumnia.net').replace(/\/+$/, '')
}
